import axios from 'axios';
import { PondsWithAerators } from 'views/production-systems/features/farm-setup/types/aerators.type';

// POST Pond Status (Aerator)
// /ewosapi/v1/shrimps/aerator/pond-status?globalSiteId={globalSiteId}&statusDate={statusDate}
export const postPondStatusAerators = async (globalSiteId: string, statusDate: string, pondIds: string[]) => {
  const res = await axios.post<PondsWithAerators>(
    `/ewosapi/v1/shrimps/aerator/pond-status?globalSiteId=${globalSiteId}&statusDate=${statusDate}`,
    {
      pondIds: pondIds,
    }
  );
  return res.data;
};
